/** Decorative font data. Never product copy or a translation of academic content. */
import asset from './arabic-glyphs.txt?raw';
const [letters, wave] = asset.trim().split('\n');
export const ARABIC_LETTERS = letters;
export const ARABIC_DITHER_WAVE = wave;
